import React from 'react';

import ai from '../../assets/adalinkMedia.png';
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">Pushing Decentralization Further</h1>
      <p>Incentivize decentralization through reward sharing between SPO's & NFT projects. AdaLink is a platform built by the community for the community.</p>
    </div>

    <div className="gpt3__header-image">
      <img src={ai} alt="ai" />
    </div>
  </div>
);

export default Header;